"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.useStyles = exports.navigationRailDrawerDefaultWidth = exports.navigationRailDrawerMinWidth = exports.navigationRailWidth = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _styles = require("@material-ui/core/styles");

var _styles2 = require("../Page/Sidebar/styles");

var navigationRailWidth = 73;
exports.navigationRailWidth = navigationRailWidth;
var navigationRailDrawerMinWidth = _styles2.mainPanelWidth - navigationRailWidth + 1; // add 1px for border offset

exports.navigationRailDrawerMinWidth = navigationRailDrawerMinWidth;
var navigationRailDrawerDefaultWidth = 276;
exports.navigationRailDrawerDefaultWidth = navigationRailDrawerDefaultWidth;
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: (0, _defineProperty2.default)({
      padding: "".concat(theme.spacing(), "px 0"),
      display: "inline-flex",
      flexDirection: "column",
      backgroundColor: theme.palette.background.paper,
      borderRight: "1px solid ".concat(theme.palette.divider),
      zIndex: 5,
      overflow: "auto",
      width: navigationRailWidth,
      height: "calc(100vh - ".concat(theme.mixins.toolbar.minHeight, "px)")
    }, theme.breakpoints.up("sm"), {
      height: "calc(100vh - ".concat(theme.mixins.toolbar.minHeight + theme.spacing(3.5), "px)")
    }),
    button: {
      paddingTop: theme.spacing(1.75),
      paddingBottom: theme.spacing(2),
      borderRadius: 0,
      "& > span": {
        display: "flex",
        flexDirection: "column"
      },
      "&:hover": {
        backgroundColor: theme.palette.action.hover
      }
    },
    drawerRoot: (0, _defineProperty2.default)({
      left: navigationRailWidth,
      zIndex: 1,
      minWidth: navigationRailDrawerMinWidth,
      width: navigationRailDrawerDefaultWidth,
      maxWidth: "60vw",
      resize: "horizontal",
      overflow: "auto",
      padding: theme.spacing(3),
      // Need to offset from the toolbar, assuming it is present
      top: theme.mixins.toolbar.minHeight,
      height: "calc(100vh - ".concat(theme.mixins.toolbar.minHeight, "px)")
    }, theme.breakpoints.up("sm"), {
      top: theme.mixins.toolbar.minHeight + theme.spacing(3.5),
      height: "calc(100vh - ".concat(theme.mixins.toolbar.minHeight + theme.spacing(3.5), "px)")
    }),
    hidden: {
      visibility: "hidden"
    },
    label: {
      lineHeight: 1.4,
      fontSize: ".85rem"
    }
  };
});
exports.useStyles = useStyles;
var _default = useStyles;
exports.default = _default;